import { render, staticRenderFns } from "./CreateBranchForm.vue?vue&type=template&id=1539d8d1&scoped=true&"
import script from "./CreateBranchForm.vue?vue&type=script&lang=js&"
export * from "./CreateBranchForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateBranchForm.vue?vue&type=style&index=0&id=1539d8d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1539d8d1",
  null
  
)

export default component.exports